module.exports = __webpack_public_path__ + "static/img/autopagebg2.bbae15d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/autopagebg2.png
// module id = 7mth
// module chunks = 1